import { Route, Routes } from 'react-router-dom'

import { lazyPage } from '@/lib/lazy-load'
import { TEAM_ID_PARAM } from '@/shared/constants'

const OrgDetailTeamDetail = lazyPage(() => import('./OrgDetailTeamDetail'))
const OrgDetailTeamIndex = lazyPage(() => import('./OrgDetailTeamIndex'))

// team routes config
const teamRoutes = [
  {
    index: true,
    component: OrgDetailTeamIndex,
    name: 'Teams',
    icon: 'Team16',
  },
  {
    path: `${TEAM_ID_PARAM}/*`,
    component: OrgDetailTeamDetail,
    name: 'Teams',
    icon: 'Team16',
  },
]

/**
 * layout of team is wrapped by route because team has detail page
 */
export default function OrgTeamsRoutes() {
  return (
    <Routes>
      {teamRoutes.map(({ component: Comp, ...rest }) => {
        return (
          <Route
            key={rest.name}
            index={rest.index}
            path={rest.index ? undefined : rest.path}
            element={<Comp title={rest.name} />}
          />
        )
      })}
    </Routes>
  )
}
